/** 共通のメッセージ */
export const COMMON_MESSAGE_STRING = {
    /** お気に入りフォルダ数上限 */
    FAVORITES_FOLDER_LIMIT_OVER: "フォルダは10個までしか登録\nすることができません。",
    /** フォルダ名上限 */
    FAVORITES_FOLDER_NAME_LIMIT_OVER: "フォルダ名は15文字以内です。"
};